// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"04f4fbe9","29":"1dc3498b","86":"9c0aa1d0","228":"5b331c4b","412":"4723d838","453":"4ea7954b"}[chunkId] + ".chunk.js";
};